import React from "react";
import "./../../UaeAttestation/UaeService/UaeService.css";
import AustraliaBloreCertHead from "../../Australia/AustraliaBloreCert/AustraliaBloreCertHead";
import LithuaniaBloreCertMain from "./LithuaniaBloreCertMain";
const LithuaniaBloreCert = () => {
  return (
    <div className="uaeServiceContainer">
    <AustraliaBloreCertHead head="Lithuania Apostille service in Bangalore for certificates" />
    <LithuaniaBloreCertMain />
  </div>
  );
};

export default LithuaniaBloreCert;
